import script from "./AgentsDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./AgentsDashboard.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import NeueLoading from "@/components/neue/NeueLoading.vue";
script.components = Object.assign({}, { NeueLoading }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { NeueLoading }, script.__o.components);}